import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Route guard: renders children only when a session exists, otherwise
 * redirects to `redirectTo` (default '/login') preserving the intended
 * path in location state. Not wired for the customer app yet (guest
 * ordering) — kept for parity with the KSS-Mart-Web pattern.
 */
export function RequireAuth({
  children,
  redirectTo = '/login'
}: {
  children: ReactNode;
  redirectTo?: string;
}) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
